export const getStandEnvironment = () => {
  const { host } = window.location;

  const isStage =
    host.includes('-stage') ||
    host.includes('.stg') ||
    host.includes('mr-') ||
    host.includes('-e2e');
  const isDev = host.includes('-dev') || host.includes('.dev');
  const isLocalhost = ['localhost', '127.0.0.1'].some(e => host.includes(e));
  const isProd = !isStage && !isLocalhost && !isDev;

  return {
    isStage,
    isLocalhost,
    isProd,
    isDev,
  };
};
